import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.5 15.25V15h-13v.25a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .44-.683h.001l.004-.003a2 2 0 0 1 .149-.062q.141-.059.404-.153c.35-.125.857-.289 1.508-.452C3.806 6.322 5.68 6 8 6s4.193.322 5.494.647c.65.163 1.159.327 1.508.452a10 10 0 0 1 .513.198l.03.014.01.003.004.002v.001h.002A.75.75 0 0 1 16 8v7.25a.75.75 0 0 1-1.5 0M8 7.5c-2.18 0-3.932.303-5.13.603-.6.15-1.061.298-1.368.408H1.5V13.5h13V8.51h-.002a15 15 0 0 0-1.367-.407C11.93 7.803 10.18 7.5 8 7.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.5 5.25V2.5h-11v2.75a.75.75 0 0 1-1.5 0V.75a.75.75 0 0 1 1.5 0V1h11V.75a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0"
    }, null, -1)
  ]))]))
}
export default { render: render }